import { render } from "./blog-details-sidebar-right.vue?vue&type=template&id=2cc6f623"
import script from "./blog-details-sidebar-right.vue?vue&type=script&lang=js"
export * from "./blog-details-sidebar-right.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__